export default {
  googleMapsApiKey: "AIzaSyCGtL5-YeAPYY0mNaBKWPCk-Z4aKzdsyzg",
};
